import services from 'services/module';
import { HttpSvcFactory } from 'services/HttpSvc';

export class StorageSvc {
    constructor(private HttpSvc: HttpSvcFactory) {}

    getStorageStats() {
        return this.HttpSvc<anm.UserStats>('profile/stats/storage').secureGet();
    }
}

services.service('storageSvc', StorageSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/StorageSvc.ts